export type AuthMode = 'local' | 'sdpm' | 'auto';

const SDPM_SSO_HOSTS = new Set([
  'hrm.sdtc.com',
  'www.hrm.sdtc.com',
  'hrm.sdtc.vn',
  'www.hrm.sdtc.vn',
]);

export const shouldRedirectToSdpmSso = (hostname: string, authMode: AuthMode): boolean => {
  if (authMode === 'local') return false;
  if (authMode === 'sdpm') return true;
  return SDPM_SSO_HOSTS.has(hostname.trim().toLowerCase());
};
